var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BillFunction',{attrs:{"pid":_vm.pid,"showType":_vm.showType,"queryInfo":_vm.queryInfo,"getBillInfo":_vm.getBillInfo},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var total = ref.total;
var handleCurrentChange = ref.handleCurrentChange;
var handleSizeChange = ref.handleSizeChange;
var queryInfo = ref.queryInfo;
return [_c('el-pagination',{attrs:{"current-page":queryInfo.currentPage,"page-sizes":[10, 20, 50, 100],"page-size":queryInfo.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":total},on:{"size-change":handleSizeChange,"current-change":handleCurrentChange}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }